import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from "react-router-dom"

import Aux from '../containers/AuxContainer'
import Background from '../assets/images/stock1.jpg'

const style = {
	backgroundImage: `url(${Background})`,
	backgroundSize: 'cover'
}

class PublicRegistrationRequirements extends Component {
	render() {
		const { match, location, project, roles, companies } = this.props
		const projectLogo = project ? project.cover_url : '';
		
		return (
			<Aux>

				<section className="gray-bg section public-registration roles-selection" style={style}>
					<div className="row">
					<div className="small-12 small-centered column text-center">
						

						<div className="container">
							<div className="callout secondary small background-none">
							  { projectLogo ? <img src={projectLogo} alt="" width="267" /> : '' }
							</div>
						</div>

						<div className="container">
							<div className="callout secondary large background-black">
							  <h5>Job Details</h5>
							  <p>{project.job_details}</p>
							</div>
						</div>

						<div className="container">
							<div className="callout secondary large background-black">
							  <h5>Roles to apply for</h5>
							  <div>
							  	{ roles 
											? roles.map( role => 
												<div key={role.id}>
												<p>{role.name}</p>
												<p>{role.description}</p></div>)
											: ''
										}
							  </div>
							</div>
						</div>

						<div className="container">
							<div className="callout secondary large background-black">
							  <h5>Specifics</h5>
							  <p>{project.specifics}</p>
							</div>
						</div>


					</div>
					</div>
				</section>

				<section className="section">
					<div className="row">
					<div className="small-12 small-centered column text-center">
						<Link className="button primary" disabled={!project.pre_registration}
						to={{ 
							pathname: '/artist/login', 
							search: location.search,
							state: {
								client: { 
									...companies[0],
									logo_url: companies[0].logo.logo.url
								},
								projectId: project
							}
						}}>{project.pre_registration ? 'Apply Now': 'SORRY THIS PROJECT IS NOW CLOSED'}</Link>
					</div>
					</div>
				</section>
				
					
			</Aux>
		)
	}
}

const mapStateToProps = state => ({
	...state.projects
})

export default connect(mapStateToProps)(PublicRegistrationRequirements)


// WEBPACK FOOTER //
// ./src/components/PublicRegistrationRequirements.js